import React, { FC } from 'react';

import { useButton, useI18n } from '~Hooks';
import Heading from '~ComponentsImproved/Typography/Heading';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import { BlueButton, TransparentButton } from '~Styles';
import ZettleImageSrc from '~Assets/Images/zettle.png';
import { HeaderBox } from '~Scenes/Onboarding/styles';

interface Props {
  isHandy?: boolean;
  onSkipClick: () => void;
}

const IZettleSettings: FC<Props> = ({ isHandy, onSkipClick }) => {
  const { i18n } = useI18n();

  const setupReaderButton = useButton({
    onClick: () => {
      window.postMessageBridge({
        showIZettleSettings: true,
      });
    },
  });

  const skipButton = useButton({
    onClick: () => {
      onSkipClick();
    },
  });

  return (
    <>
      <HeaderBox
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="xs"
        justifyContent="center"
        marginBottom="small">
        <img
          style={{ borderRadius: '8px' }}
          src={ZettleImageSrc}
          alt="Zettle"
          height={isHandy ? '64px' : '96px'}
        />
        <Heading level={isHandy ? 3 : 1} color="var(--colorWhite)">
          {i18n('Onboarding.ZettleConfig')}
        </Heading>
        <Paragraph level={isHandy ? 5 : 2} color="var(--colorBlueGray200)">
          {i18n('Onboarding.ZettleConfig.Text')}
        </Paragraph>
      </HeaderBox>

      <BlueButton {...setupReaderButton}>{i18n('Onboarding.SetUpReader')}</BlueButton>

      <TransparentButton {...skipButton}>
        <Paragraph level={3} color="var(--colorBlueGray200)">
          {i18n('Onboarding.SkipContinue')}
        </Paragraph>
      </TransparentButton>
    </>
  );
};

export default IZettleSettings;
